<template>
	<div :id="id" class="panel panel-basic" :class="[ collapsable ? 'collapsable': '' , panelClass ]">
		<div class="panel-heading"
				 data-toggle="collapse"
				 :data-target="collapseTarget"
				 v-if="collapsable"
				 @click="showBody = !showBody">
			<h2 class="panel-title">
				<slot name="title">
					<slot name="icon">
						<font-awesome-icon :icon="iconClass" aria-hidden="true" v-if="!!iconClass"></font-awesome-icon>
					</slot> 
					<span v-html="title"></span>
					<i class="fa fa-info-circle" v-if="helpText" v-tooltip.top-center="{content: `${helpText}`, trigger: 'hover click'}" />
					<span class="badge" :class="badgeClass" v-if="hasBadge && !!badgeContent">{{ badgeContent }}</span>
				</slot>
				<template v-if="useCollapseExpandCarrots">
					<font-awesome-icon icon="caret-up" v-if="showBody" style="position: absolute; right: 12px; color: #0E76BD;">
					</font-awesome-icon>
					<font-awesome-icon icon="caret-down" v-else style="position: absolute; right: 12px; color: #0E76BD;">
					</font-awesome-icon>
				</template>
			</h2>
		</div>
		<div class="panel-heading" :class="badgeClass" v-else>
			<h2 class="panel-title">
				<slot name="title">
					<slot name="icon">
						<font-awesome-icon :icon="iconClass" aria-hidden="true" v-if="!!iconClass"></font-awesome-icon>
					</slot>
					<span v-html="title"></span>
					<i class="fa fa-info-circle" v-if="helpText" v-tooltip.top-center="{content: `${helpText}`, trigger: 'hover click'}" />
					<span class="badge" v-if="hasBadge">{{ badgeContent }}</span>
				</slot>
			</h2>
		</div>
		<div class="panel-body collapse in" :id="bodyID" :style="{'max-height': maxHeight + 'px', 'overflow': overflow}" v-show="showBody">
			<slot></slot>
		</div>
		<div class="panel-footer" v-if="showFooter">
			<slot name="panel-footer"></slot>
		</div>
	</div>
</template>

<script>
	import '../../imports/fontAwesome.js';
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import { library } from '@fortawesome/fontawesome-svg-core';

	import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
	import { VTooltip } from 'v-tooltip';
	library.add(faCaretDown);
	library.add(faCaretUp);

	export default {
		// id 			:  Panel id
		// panelClass 	: Panel class to overwrite default panel CSS
		// title 		: Panel title
		// collapsable 	: Panel is collapsable if set to true
		// maxHeight 	: Max height of the panel body
		// hasBadge		: Badge will display next to title if set to true
		// badgeContent	: Badge content
		// badgeClass	: Badge class
		name: 'PanelBasic',
		props: {
			id: {
				type: String,
				required: true
			},
			helpText: {
				type: String,
				required: false
			},
			panelClass: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: ''
			},
			collapsable: {
				type: Boolean,
				default: false
			},
			maxHeight: {
				type: Number,
				required: false
			},
			hasBadge: {
				type: Boolean,
				default: false
			},
			badgeContent: {
				default: ''
			},
			badgeClass: {
				type: String,
				default: ''
			},
			showFooter: {
				type: Boolean,
				default: false
			},
			overflow: {
				type: String,
				default: 'auto'
			},
			iconClass: {
				type: String,
				default: ''
			},
			defaultCollapsed: {
				type: Boolean,
				default: false
			},
			useCollapseExpandCarrots: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				showBody: true
			};
		},
		computed: {
			bodyID() {
				return 'panel-body-' + this.id ;
			},
			collapseTarget() {
				return '#panel-body-' + this.id;
			}
		},
		components: {
			FontAwesomeIcon,
			VTooltip
		},
		mounted() {
			if(this.defaultCollapsed) {
				this.showBody = false;
			}
		}
	}
</script>
